var _excluded = ["value", "limit", "limitErrorMessage", "descriptions", "onChange", "bizKey", "handleUpload", "setFieldError", "className", "validateField", "containerRef", "placeholder"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useEffect, useState, useContext, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Upload } from 'antd';
import Modal from "../modal";
import { colors } from 'iglootheme';
import invariant from 'invariant';
import classnames from 'classnames';
import UploadPreview from "../upload-preview";
import "./style";
import { UploadOutlined, CrossOutlined, ShowOutlined, RefreshOutlined, LoadingOutlined, FileOutlined } from 'iglooicon';
import Typography from "../typography";
import { parseFileSize } from "../utils/tools";
import { LocaleContext } from "../locale";
import Preview from "../upload-preview/media";
import { classifyType } from "../utils/tools";
import FormContext from "../form-context";
import { staticFormatMessage } from "../locale";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Dragger = Upload.Dragger;
var IglooUpload = function IglooUpload(props) {
  var limitNumError = useRef();
  var DomRef = useRef();
  var dataUrlRef = useRef([]);
  var _useContext = useContext(FormContext),
    uploadApi = _useContext.uploadApi;
  var _useContext2 = useContext(LocaleContext),
    formatMessage = _useContext2.formatMessage;
  var staticMessage = formatMessage({
    id: 'File Uploading'
  });
  invariant(typeof props.handleUpload === 'function' || uploadApi, '"handleUpload" should be a function. Or uploadApi should be set at Form/FreeForm');
  invariant(!uploadApi || props.bizKey, '"bizKey" should be set if Upload is used with uploadApi');
  var value = props.value,
    limit = props.limit,
    limitErrorMessage = props.limitErrorMessage,
    descriptions = props.descriptions,
    onChange = props.onChange,
    bizKey = props.bizKey,
    _props$handleUpload = props.handleUpload,
    handleUpload = _props$handleUpload === void 0 ? /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
        var formData, response, error, rst;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              formData.append('biz_key', bizKey);
              _context.next = 5;
              return fetch(uploadApi, {
                method: 'post',
                body: formData
              });
            case 5:
              response = _context.sent;
              if (response.ok) {
                _context.next = 11;
                break;
              }
              _context.next = 9;
              return response.json();
            case 9:
              error = _context.sent;
              throw new Error(error.message || 'upload failed');
            case 11:
              _context.next = 13;
              return response.json();
            case 13:
              rst = _context.sent;
              return _context.abrupt("return", rst.url);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }() : _props$handleUpload,
    setFieldError = props.setFieldError,
    className = props.className,
    validateField = props.validateField,
    containerRef = props.containerRef,
    placeholder = props.placeholder,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  useEffect(function () {
    var removeLimitMsg = function removeLimitMsg(e) {
      if (!(files !== null && files !== void 0 && files.length)) {
        return;
      }
      if (DomRef.current && !DomRef.current.contains(e.target) && limitNumError.current) {
        validateField && validateField();
        limitNumError.current = undefined;
      }
    };
    window.addEventListener('click', removeLimitMsg);
    return function () {
      window.removeEventListener('click', removeLimitMsg);
    };
  }, [files]);
  useEffect(function () {
    if (limitNumError.current) {
      setFieldError && setFieldError(limitNumError.current);
      return;
    }
  });

  // 有初始值的处理 (不是初始化)
  useEffect(function () {
    if (Array.isArray(value) && value.length && files.length === 0) {
      var _files = (value || []).map(function (url, index) {
        return {
          url: url,
          dataUrl: url,
          status: 'success',
          type: '',
          name: "File".concat(index + 1),
          size: 0,
          uid: index
        };
      });
      setFiles(_files);
    }
  }, [value]);
  useEffect(function () {
    return function () {
      dataUrlRef.current.forEach(function (dataUrl) {
        URL.revokeObjectURL(dataUrl);
      });
    };
  }, []);
  useEffect(function () {
    if (!value && !files.length) return;
    if (files.length) {
      var hasProcessing = files.find(function (f) {
        return f.status === 'progress';
      });
      if (hasProcessing) {
        onChange && onChange({
          status: 'processing'
        });
        return;
      }
      var urls = files.map(function (f) {
        var status = f.status,
          name = f.name,
          errorMsg = f.errorMsg;
        if (status === 'failed') {
          return {
            name: name,
            errorMsg: errorMsg
          };
        }
        return f.url;
      });
      onChange && onChange(urls);
    } else {
      onChange && onChange(undefined);
    }
  }, [files]);
  invariant(limit === undefined || limit > 0, "\"limit\" should be a pasitive number.");
  var onUpload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
      var dataUrl, name, size, type, uid, errorMsg;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dataUrl = URL.createObjectURL(file);
            dataUrlRef.current.push(dataUrl);
            name = file.name, size = file.size, type = file.type, uid = file.uid;
            if (!(limit && files.length >= limit)) {
              _context2.next = 8;
              break;
            }
            errorMsg = (typeof limitErrorMessage === 'function' ? limitErrorMessage(value) : limitErrorMessage) || formatMessage({
              id: 'Quantity of files should be less than {limit}',
              values: {
                limit: limit
              }
            });
            limitNumError.current = errorMsg;
            setFieldError && setFieldError(errorMsg);
            return _context2.abrupt("return", Promise.reject(errorMsg));
          case 8:
            limitNumError.current = undefined;

            // 上传过程中 status为‘progress’，后续通过state更新
            setFiles(function (files) {
              return [].concat(_toConsumableArray(files), [{
                name: name,
                type: type,
                size: size,
                dataUrl: dataUrl,
                status: 'progress',
                originFile: file,
                uid: uid
              }]);
            });

            // 符合文件个数限制之后 上传时的错误处理
            return _context2.abrupt("return", handleUploadPromise(file, function (url) {
              return setFiles(function (files) {
                return files.map(function (f) {
                  if (f.uid === uid) {
                    return _objectSpread(_objectSpread({}, f), {}, {
                      url: url,
                      status: 'success'
                    });
                  }
                  return f;
                });
              });
            }, function (errorMsg) {
              return setFiles(function (files) {
                return files.map(function (f) {
                  if (f.uid === uid) {
                    return _objectSpread(_objectSpread({}, f), {}, {
                      status: 'failed',
                      errorMsg: errorMsg
                    });
                  }
                  return f;
                });
              });
            }));
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onUpload(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUploadPromise = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file, onSuccess, onFailed) {
      var rst, errorMsg;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return handleUpload(file);
          case 3:
            rst = _context3.sent;
            onSuccess(rst);
            return _context3.abrupt("return", Promise.resolve(rst));
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            errorMsg = _typeof(_context3.t0) === 'object' ? _context3.t0.message : _context3.t0;
            onFailed(errorMsg);
            return _context3.abrupt("return", Promise.reject(errorMsg));
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 8]]);
    }));
    return function handleUploadPromise(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  // 错误提示的优先级，上传报错 > 'quantity of files should be less than {limit}' > 'Please re-upload this file:{name}'
  var handleDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(index) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            limitNumError.current = null;
            setFiles(function (files) {
              var newArr = files.filter(function (_, i) {
                return i !== index;
              });
              return newArr;
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleDelete(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleReUpload = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(index) {
      var _files$index, originFile, reUpUid, rst;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _files$index = files[index], originFile = _files$index.originFile, reUpUid = _files$index.uid;
            if (originFile) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return");
          case 3:
            _context5.next = 5;
            return setFiles(function (files) {
              var newFiles = _toConsumableArray(files);
              newFiles[index].status = 'progress';
              return newFiles;
            });
          case 5:
            _context5.prev = 5;
            _context5.next = 8;
            return handleUpload(originFile);
          case 8:
            rst = _context5.sent;
            _context5.next = 11;
            return setFiles(function (files) {
              var newFiles = _toConsumableArray(files);
              newFiles[index].url = rst;
              newFiles[index].status = 'success';
              return newFiles;
            });
          case 11:
            _context5.next = 17;
            break;
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](5);
            _context5.next = 17;
            return setFiles(function (files) {
              var newFiles = _toConsumableArray(files);
              newFiles[index].status = 'failed';
              newFiles[index].errorMsg = _context5.t0;
              return newFiles;
            });
          case 17:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[5, 13]]);
    }));
    return function handleReUpload(_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handlePreview = function handlePreview(index) {
    var _files$index2 = files[index],
      dataUrl = _files$index2.dataUrl,
      name = _files$index2.name,
      type = _files$index2.type;
    Modal.noFooter({
      content: /*#__PURE__*/_jsx(Preview, {
        src: dataUrl,
        type: classifyType(type)
      }),
      title: name,
      className: 'igloo-upload-preview-modal',
      maskClosable: true,
      closable: true
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('igloo-upload', className),
    id: rest.id,
    ref: DomRef,
    children: [descriptions && /*#__PURE__*/_jsx("div", {
      className: "igloo-upload-descriptions",
      children: descriptions
    }), /*#__PURE__*/_jsx(Dragger, _objectSpread(_objectSpread({
      action: onUpload
    }, rest), {}, {
      showUploadList: false,
      className: "igloo-upload-box",
      customRequest: function customRequest() {},
      multiple: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: "igloo-upload-box-center",
        children: [/*#__PURE__*/_jsx(UploadOutlined, {
          style: {
            marginRight: 16,
            fontSize: 24,
            color: '#666666'
          }
        }), /*#__PURE__*/_jsx("span", {
          className: "igloo-upload-placeholder",
          children: placeholder || /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Typography, {
              level: "body1",
              children: formatMessage({
                id: 'Drag and drop a file here'
              })
            }), /*#__PURE__*/_jsx(Typography, {
              level: "body1",
              style: {
                marginLeft: 4
              },
              children: formatMessage({
                id: 'or'
              })
            }), /*#__PURE__*/_jsx(Typography, {
              level: "body1",
              style: {
                color: colors.purpleMain,
                marginLeft: 4
              },
              children: formatMessage({
                id: 'browse'
              })
            })]
          })
        })]
      })
    })), !!files.length && /*#__PURE__*/_jsx(FileList, {
      files: files,
      limit: limit,
      handleReUpload: handleReUpload,
      handlePreview: handlePreview,
      handleDelete: handleDelete,
      containerRef: containerRef,
      disabled: props.disabled
    })]
  });
};
var FileList = function FileList(_ref6) {
  var containerRef = _ref6.containerRef,
    files = _ref6.files,
    limit = _ref6.limit,
    handleDelete = _ref6.handleDelete,
    handlePreview = _ref6.handlePreview,
    handleReUpload = _ref6.handleReUpload,
    disabled = _ref6.disabled;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    initDone = _useState4[0],
    setInitDone = _useState4[1];
  useEffect(function () {
    return setInitDone(true);
  }, [containerRef.current]);
  if (!initDone) return null;
  var children = /*#__PURE__*/_jsx("div", {
    className: "igloo-upload-preview-list",
    children: files.map(function (_ref7, index) {
      var type = _ref7.type,
        name = _ref7.name,
        size = _ref7.size,
        status = _ref7.status;
      return /*#__PURE__*/_jsxs("div", {
        className: classnames('igloo-upload-preview-item', {
          'igloo-upload-preview-item-failed': status === 'failed'
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "igloo-upload-preview-item-info",
          children: [status !== 'progress' && /*#__PURE__*/_jsx(FileOutlined, {
            style: {
              marginRight: 8,
              fontSize: 24,
              color: '#999999'
            },
            className: "igloo-upload-preview-item-icon"
          }), status === 'progress' && /*#__PURE__*/_jsx(LoadingOutlined, {
            className: "igloo-upload-preview-item-icon igloo-upload-uploading",
            style: {
              marginRight: 8,
              fontSize: 24,
              color: '#999999'
            }
          }), /*#__PURE__*/_jsxs("div", {
            className: "igloo-upload-preview-item-text",
            children: [/*#__PURE__*/_jsx("span", {
              className: "igloo-upload-preview-item-name",
              children: /*#__PURE__*/_jsx(Typography, {
                level: "h4",
                children: name
              })
            }), Boolean(size) && /*#__PURE__*/_jsx("span", {
              className: "igloo-upload-preview-item-size",
              children: /*#__PURE__*/_jsx(Typography, {
                level: "body1",
                children: parseFileSize(size)
              })
            })]
          })]
        }), status === 'success' && /*#__PURE__*/_jsxs("div", {
          className: "igloo-upload-preview-item-operation",
          children: [type && /*#__PURE__*/_jsx(ShowOutlined, {
            style: {
              fontSize: 24,
              color: '#999999',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              return handlePreview(index);
            },
            className: 'igloo-upload-preview-item-operation-left-icon'
          }), /*#__PURE__*/_jsx(CrossOutlined, {
            style: {
              fontSize: 24,
              color: '#999999',
              cursor: disabled ? 'default' : 'pointer'
            },
            onClick: function onClick() {
              return !disabled && handleDelete(index);
            }
          })]
        }), status === 'failed' && /*#__PURE__*/_jsxs("div", {
          className: "igloo-upload-preview-item-operation",
          children: [(!limit || index < limit) && /*#__PURE__*/_jsx(RefreshOutlined, {
            style: {
              fontSize: 24,
              color: '#999999',
              cursor: disabled ? 'default' : 'pointer'
            },
            onClick: function onClick() {
              return !disabled && handleReUpload(index);
            },
            className: 'igloo-upload-preview-item-operation-left-icon'
          }), /*#__PURE__*/_jsx(CrossOutlined, {
            style: {
              fontSize: 24,
              color: '#999999',
              cursor: disabled ? 'default' : 'pointer'
            },
            onClick: function onClick() {
              return !disabled && handleDelete(index);
            }
          })]
        })]
      }, index);
    })
  });
  return /*#__PURE__*/ReactDOM.createPortal(children, containerRef.current);
};
function checkFileList(value) {
  if ((value === null || value === void 0 ? void 0 : value.status) === 'processing') {
    return Promise.reject(staticFormatMessage({
      id: 'File Uploading'
    }));
  }
  if (!value) {
    return Promise.resolve();
  }
  for (var i = 0; i < value.length; i++) {
    var _file = value[i];
    if (_typeof(_file) === 'object') {
      var errorMsg = _file.errorMsg;
      return Promise.reject(errorMsg);
    }
  }
  return Promise.resolve();
}
IglooUpload.formItemPropsHandler = function (_ref8) {
  var previewFormater = _ref8.previewFormater,
    label = _ref8.label;
  return {
    previewFormater: previewFormater || function (value) {
      return /*#__PURE__*/_jsx(UploadPreview, {
        label: label,
        files: value
      });
    },
    fullRow: true,
    rules: [{
      validator: function validator(_, value) {
        return checkFileList(value);
      }
    }]
  };
};
export default IglooUpload;